// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5_DMd","newExpiryDate":"styles_newExpiryDate__3h6jy","footer":"styles_footer__1zYEo"};